"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  name: 'Script Planner',
  description: 'Plan your project and create scripts before shooting your content. Use our Cue app to automatically play through your script.',
  icon: 'script',
  link: 'scripts',
  isNew: false
}, {
  name: 'Storyboard Planner',
  description: 'Plan your project and create storyboards before shooting your content. Integrate your scripts in a visual way.',
  icon: 'storyboard',
  link: 'storyboards',
  isNew: false
}, {
  name: 'Cue App',
  description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do tempor incididunt eiusmod labore et maniqua sit aliqua.',
  icon: 'shot',
  link: '',
  isNew: false
}, {
  name: 'Visual Brief Editor Tool',
  description: 'Upload your footage and build great video content.',
  icon: 'projects',
  link: 'video-tool',
  isNew: false
}, {
  name: 'Inspirations',
  description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit sed do tempor incididunt eiusmod labore et maniqua sit aliqua.',
  icon: 'inspiration',
  link: 'inspiration',
  isNew: false
}];
exports.default = _default;